/* import __COLOCATED_TEMPLATE__ from './categories-topic-list.hbs'; */
import Component from "@ember/component";
// Exists so plugins can use it
export default class CategoriesTopicList extends Component {}
